import { PayloadAction, createSlice } from '@reduxjs/toolkit';
export const BET_FAIL_SUMMARY_KEY = 'app::report::fail::summary';
export type FailSummary = {
    ReportDate: string;
    ResultAmount: number;
    RollingAmount: number;
    TurnOverAmount: number;
};
export type BetFailSummaryState = {
    summaries: Array<FailSummary>;
};

const updateSummary = (
    state: BetFailSummaryState,
    actions: PayloadAction<BetFailSummaryState>
) => {
    state.summaries = actions.payload.summaries;
};
const reset = (state: BetFailSummaryState) => {
    state.summaries = initialBetFailSummary.summaries;
};
const initialBetFailSummary = {} as BetFailSummaryState;
const betFailSummarySlice = createSlice({
    name: BET_FAIL_SUMMARY_KEY,
    initialState: initialBetFailSummary,
    reducers: {
        updateSummary,
        reset,
    },
});
export const betFailSummarySliceReducer = betFailSummarySlice.reducer;
export const betFailSummarySliceActions = betFailSummarySlice.actions;
